import actionTypes from '../constants/action-types';

const setClipboardData = (data) => ({
  type: actionTypes.SET_CLIPBOARD_DATA,
  payload: {
    data,
  },
});

export default setClipboardData;
